import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import moment from "moment";
import { InputItem, InputNumberItem, RangePickerItem, SelectItem } from "../../../Components/Items";
import SelectClientesItem from "../../../Components/SelectClientesItem";
import SelectProyectosItem from "../../../Components/SelectProyectosItem";
import SelectUsuariosItem from "../../../Components/SelectUsuariosItem";
import SelectEscuelasItem from "../../../Components/SelectEscuelasItem";

const OPCIONES_BOOLEANO = [
  { value: true, label: "Sí" },
  { value: false, label: "No" },
];

const COMPONENTES_ESPECIALES = {
  SelectClientesItem,
  SelectProyectosItem,
  SelectUsuariosItem,
  SelectEscuelasItem,
};

function SelectGenericoPorEndpoint({ filtroUI, empresaId, headersToken, valor, onChange }) {
  const [opciones, setOpciones] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    setCargando(true);
    axios
      .post(filtroUI.endpoint, { empresaId }, { headers: headersToken })
      .then((res) => {
        const lista = filtroUI.campoRespuesta ? res.data[filtroUI.campoRespuesta] : res.data;
        setOpciones(Array.isArray(lista) ? lista : []);
      })
      .finally(() => setCargando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroUI.endpoint, empresaId]);

  const options = opciones.map((o) => ({
    value: o[filtroUI.campoValor || "_id"],
    label: filtroUI.camposLabel.map((campo) => o[campo]).join(" - "),
  }));

  return (
    <SelectItem
      allowClear
      loading={cargando}
      mode={filtroUI.modoMultiple ? "multiple" : undefined}
      options={options}
      value={valor}
      onChange={onChange}
      style={{ width: "100%" }}
    />
  );
}

function ControlDeFiltro({ campo, valor, onChange, empresaId, headersToken }) {
  if (campo.filtroUI?.tipo === "componente") {
    const Componente = COMPONENTES_ESPECIALES[campo.filtroUI.componente];
    if (Componente) {
      return (
        <Componente
          empresaId={empresaId}
          headersToken={headersToken}
          mode={campo.filtroUI.modoMultiple ? "multiple" : undefined}
          value={valor}
          onChange={onChange}
          placeholder={campo.label}
          width="100%"
        />
      );
    }
  }

  if (campo.filtroUI?.tipo === "select") {
    return (
      <SelectGenericoPorEndpoint
        filtroUI={campo.filtroUI}
        empresaId={empresaId}
        headersToken={headersToken}
        valor={valor}
        onChange={onChange}
      />
    );
  }

  switch (campo.tipo) {
    case "numero":
    case "moneda":
      return (
        <div style={{ display: "flex", gap: 6 }}>
          <InputNumberItem
            placeholder="Mín."
            dinero={campo.tipo === "moneda"}
            value={valor?.min}
            onChange={(min) => onChange({ ...valor, min })}
            style={{ width: "50%" }}
          />
          <InputNumberItem
            placeholder="Máx."
            dinero={campo.tipo === "moneda"}
            value={valor?.max}
            onChange={(max) => onChange({ ...valor, max })}
            style={{ width: "50%" }}
          />
        </div>
      );

    case "fecha":
      return (
        <RangePickerItem
          value={valor?.desde && valor?.hasta ? [moment(valor.desde), moment(valor.hasta)] : null}
          onChange={(fechas) =>
            onChange(
              fechas
                ? { desde: fechas[0].startOf("day").toISOString(), hasta: fechas[1].endOf("day").toISOString() }
                : null
            )
          }
          style={{ width: "100%" }}
        />
      );

    case "booleano":
      return (
        <SelectItem
          allowClear
          options={OPCIONES_BOOLEANO}
          value={valor}
          onChange={onChange}
          style={{ width: "100%" }}
        />
      );

    case "seleccion":
      return (
        <SelectItem
          allowClear
          options={campo.opciones || []}
          value={valor}
          onChange={onChange}
          style={{ width: "100%" }}
        />
      );

    case "texto":
    case "relacion":
    default:
      return (
        <InputItem
          allowClear
          placeholder={`Buscar por ${campo.label.toLowerCase()}...`}
          value={valor || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
  }
}

function PanelFiltrosReporte({ campos, value, onChange, empresaId, headersToken }) {
  const [borrador, setBorrador] = useState(value || {});
  const timeoutRef = useRef(null);

  useEffect(() => {
    setBorrador(value || {});
  }, [value]);

  const camposFiltrables = campos.filter((c) => c.filtrable);
  if (camposFiltrables.length === 0) return null;

  const actualizarCampo = (key, nuevoValor, inmediato) => {
    const nuevoBorrador = { ...borrador, [key]: nuevoValor };
    setBorrador(nuevoBorrador);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (inmediato) {
      onChange(nuevoBorrador);
    } else {
      timeoutRef.current = setTimeout(() => onChange(nuevoBorrador), 500);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        margin: "12px 0",
        padding: "12px",
        backgroundColor: "#fafafa",
        borderRadius: 8,
        border: "1px solid #f0f0f0",
      }}
    >
      {camposFiltrables.map((campo) => {
        const esInmediato = !!campo.filtroUI || campo.tipo === "seleccion" || campo.tipo === "booleano" || campo.tipo === "fecha";
        return (
          <div key={campo.key} style={{ minWidth: 220, flex: "1 1 220px" }}>
            <div style={{ fontSize: 12, color: "#595959", marginBottom: 4 }}>{campo.label}</div>
            <ControlDeFiltro
              campo={campo}
              valor={borrador[campo.key]}
              onChange={(v) => actualizarCampo(campo.key, v, esInmediato)}
              empresaId={empresaId}
              headersToken={headersToken}
            />
          </div>
        );
      })}
    </div>
  );
}

export default PanelFiltrosReporte;
